export default __webpack_public_path__ + "static/media/9Y.fc2b075e.png";